/* eslint-disable import/no-anonymous-default-export */
import http from '../../helpers/http'
import httpsync from '../../helpers/httpsync'
import qs from 'qs'

export default {
    getAsset: (token, limit, search, page, tipe, time1, time2) => ({
        type: 'GET_ASSETHISTORY',
        payload: http(token).get(`/asset-history/get?limit=${limit}&search=${search}&page=${page === undefined ? 1 : page}&sort=id&tipe=${tipe === undefined ? 'all' : tipe}&time1=${time1}&time2=${time2}`)
    }),
    getAssetAll: (token, limit, search, page, tipe, area) => ({
        type: 'GET_ASSETHISTORYALL',
        payload: http(token).get(`/asset-history/all?limit=${limit}&search=${search}&page=${page === undefined ? 1 : page}&sort=id&tipe=${tipe === undefined ? 'all' : tipe}&area=${area === undefined ? 'all' : area}`)
    }),
    getDetailAsset: (token, no) => ({
        type: 'GET_DETAIL',
        payload: http(token).get(`/asset-history/detail/${no}`)
    }),
    nextPage: (token, link) => ({
        type: 'NEXT_DATA_ASSETHISTORY',
        payload: http(token).get(`${link}`)
    }),
    updateAsset: (token, id, data) => ({
        type: 'UPDATE_ASSETHISTORY',
        payload: http(token).patch(`/asset-history/update/${id}`, qs.stringify(data))
    }),
    uploadMasterAsset: (token, data) => ({
        type: 'UPLOAD_ASSETHISTORY',
        payload: http(token).post(`/asset-history/master`, data)
    }),
    updateAssetNew: (token, id, data) => ({
        type: 'UPDATE_ASSETHISTORYNEW',
        payload: http(token).patch(`/asset-history/update/${id}`, qs.stringify(data))
    }),
    syncAsset: (token, type, noAset, date1) => ({
        type: 'SYNC_ASSETHISTORY',
        payload: httpsync(token).get(`/asset-history/sync?type=${type}&noAset=${noAset}&date1=${date1}`),
    }),
    resetError: () => ({
        type: 'RESET_ASSETHISTORY'
    }),
    resetData: () => ({
        type: 'RESET_DATA'
    })
}